export function resolveLinkedProfileId(
  selectedProfileId?: number | null,
  sensorProfileId?: number | null,
): number | null {
  return selectedProfileId ?? sensorProfileId ?? null
}

export function hasAlarmProfileForActivation(
  isCurrentlyActive: boolean,
  profileId?: number | null,
  storedProfileId?: number | null,
): boolean {
  if (isCurrentlyActive) return true
  return resolveLinkedProfileId(profileId, storedProfileId) != null
}

export function shouldBlockAlarmActivation(
  isCurrentlyActive: boolean,
  nextActive: boolean,
  linkedProfileId: number | null,
): boolean {
  return !isCurrentlyActive && nextActive && linkedProfileId == null
}
